import { pushToWeakListener } from '@bcflit-v1-ui-shared/weak-listener/push-to-weak-listener';
import { QueryParams } from '@bcflit-v1-ui-shared/weak-listener/types';

export function routerUpdateQueryParams(queryParams: QueryParams, strategy?: 'merge'): void {
  pushToWeakListener('do-router-update-query-params', {
    queryParams: queryParams,
    strategy: strategy
  });
}
